import React, { useState, useEffect } from 'react';
import { Widget, FormInput, MasterDetailForm, Button, Col, notification } from '@digital/ui';
import ReactHtmlParser from 'react-html-parser';
import { Modal, Tooltip } from 'antd';
import { List } from 'antd';
import { SendMail, postEnviarEmail } from '../../../api/log';
import * as Yup from 'yup';

interface FormEnviarEmailProp {
  mostrarModal: boolean;
  htmlTexto: string;
  email: string;
  cc: string;
  ccEmailTela: string[];
  emailLogId: string;
  onAfterSend?: () => void;
}

const FormEnviarEmail = (props: FormEnviarEmailProp) => {
  const { mostrarModal, htmlTexto, email, cc, ccEmailTela, emailLogId, onAfterSend } = props;
  const [showModal, setShowModal] = useState<boolean>(mostrarModal);
  const [listEmailCc, setListEmailCc] = useState<string[]>(ccEmailTela);
  const [novoEmail, setNovoEmail] = useState<string>();
  const [emailValue, setEmailValue] = useState<string>(email);

  useEffect(() => { }, []);

  const removeMail = (email: string) => {
    const index = listEmailCc.indexOf(email);
    if (index > -1) {
      listEmailCc.splice(index, 1);
    }

    const novosEmails = [] as string[];
    listEmailCc.map(email => {
      novosEmails.push(email);
    });
    setListEmailCc(novosEmails);
  };

  const envairEmail = async (sendMail: SendMail) => {
    if (!emailValido(emailValue)) {
      notification.error('E-mail é um campo obrigatório');
      return;
    };

    const result = await postEnviarEmail(sendMail);
    if (result) {
      notification.success('E-mail reenviado com sucesso');
      setShowModal(false);
      if (onAfterSend) onAfterSend();
    }
  };

  const emailValido = (email: string = ''): boolean => {
    const validateEmail = Yup.object().shape({
      email: Yup.string()
        .email()
        .required(),
    });
    return validateEmail.isValidSync({ email }).valueOf();
  };

  return (
    <div>
      <Tooltip title="Visualizar E-mail">
        <Button
          type="link"
          icon="mobile-read_message"
          size="small"
          onClick={() => {
            setShowModal(true);
          }}
        />
      </Tooltip>
      <Modal
        visible={showModal}
        width={1240}
        title="Detalhe do E-mail"
        onCancel={() => {
          setShowModal(false);
        }}
        footer={[
          <Button
            key="back"
            type="link"
            onClick={() => {
              setShowModal(false);
            }}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              const sendMail = {} as SendMail;
              sendMail.email = emailValue;
              sendMail.cc = listEmailCc;
              sendMail.id = emailLogId;
              envairEmail(sendMail);
            }}>
            Enviar
          </Button>,
        ]}>
        <MasterDetailForm initialValues={{ cc, ccEmailTela }}>
          <Widget actions={[]}>
            <FormInput
              label="E-mail"
              required={true}
              name="email"
              span={12}
              value={emailValue}
              onChange={e => {
                setEmailValue(e.target.value);
              }}
            />
            <FormInput
              label="Novo E-Mail"
              name="novoEmail"
              span={12}
              onChange={e => {
                setNovoEmail(e.target.value);
              }}
            />
            <Col>
              <Button
                disabled={!emailValido(novoEmail)}
                key="submit"
                type="primary"
                onClick={() => {
                  const novosEmails = [] as string[];
                  listEmailCc.map(email => {
                    novosEmails.push(email);
                  });

                  const emailExist = novosEmails.filter(email => {
                    return novoEmail == email;
                  });

                  if (novoEmail && emailExist.length === 0) novosEmails.push(novoEmail);
                  setListEmailCc(novosEmails);
                }}>
                Incluir
              </Button>

              <List
                header={<div>E-mail(s) em Cópia</div>}
                className="multiple-item-list"
                dataSource={listEmailCc}
                renderItem={item => (
                  <List.Item
                    actions={[
                      <a
                        key="list-loadmore-edit"
                        onClick={e => {
                          removeMail(item);
                        }}>
                        Excluir
                      </a>,
                    ]}>
                    {item}
                  </List.Item>
                )}
              />
              <br />
              <p>{ReactHtmlParser(htmlTexto)}</p>
            </Col>
          </Widget>
        </MasterDetailForm>
      </Modal>
    </div >
  );
};

export default FormEnviarEmail;
